import React from 'react';
import { StyledText } from "../../../../components/common/basic";

const RewardItemCard = ({ color, image, points, name, status, showStatus = false, onClick = () => { } }) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '12px 15px',
        background: '#F2F2F2',
        marginBottom: '10px'
      }}>
      <img src={image} style={{ width: '100px' }} />
      <div style={{ marginLeft: '17px' }}>
        <div>
          <StyledText size={18} style={{ margin: '2px 0' }}>{name}</StyledText>
          <span style={{
            background: color,
            display: 'inline-block',
            padding: '5px',
            fontSize: '11px',
            fontFamily: 'MTNBold',
            color: '#fff'
          }}>{points}</span>
        </div>
        {
          showStatus &&
          <StyledText size={12} style={{ margin: '20px 0 2px 0' }} color={status !== 'ready' ? "#F5821E" : '#0FAF4B'}>
            {status !== 'ready' ? 'Pending' : 'Ready'}
          </StyledText>
        }
      </div>
    </div>
  )
}

export default RewardItemCard;